const KEY = "aavedak-auth-session";

export const getStoredSession = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setStoredSession = (session) => {
  localStorage.setItem(KEY, JSON.stringify(session));
};

export const clearStoredSession = () => {
  localStorage.removeItem(KEY);
};
